/**
 * 刺繍の選択（モーダル）
 *
 * 商品ページの「刺繍を選ぶ」でモーダルを開き、モチーフ → お名前（書体・糸色を含む）→ 内容確認 の順に進んでもらう。
 * 下のボタンは、次にやることがあれば「次へ」、内容確認でチェックが入れば「カートに追加」で押せるようになる。
 * カートに入れるときは、選んだ内容を properties[モチーフ]・[お名前]・[書体]・[糸色] に入れて商品フォームを送信する。
 * 内容確認の手順で同意を取り、チェックが入るまでカートに入れられない（2026-11-02 彩華さん。カートのチェック欄から移した）。
 * チェックのあとに内容を変えたら外す。同意した文言は properties[_同意] に入れて注文に残す（先頭が _ なのでお客様の画面には出ない）。
 * カートへの追加とカートドロワーの表示はテーマ（product-form）のまま。
 *
 * お名前とモチーフはどちらか一方だけでも成立する。両方「入れない」にはできない。
 * 書体と糸色はお名前に適用されるため、お名前を入れない場合は選ばない。
 * 刺繍の加算料金はないので、価格に関する処理はない。
 */
(function () {
  'use strict';

  if (customElements.get('embroidery-options')) return;

  // 刺繍できる文字。書体が欧文のためローマ字と数字に限定する。大文字・小文字はどちらも刺繍できる
  var ALLOWED = /^[A-Za-z0-9 .&'-]$/;

  // 書体は3つから選ぶ（2026-10-28 彩華さん）。ゴシックは本物の Aqua Grotesque（2026-11-01）。この書体に無い & と ' だけ Didact Gothic で出る。
  // イタリックは本物の Calgary MediumItalic（2026-11-01）。筆記体は刺しゅうPROの画面の画像から起こした Script 4（2026-11-02。英字のみ。数字と記号だけ Dancing Script で出る）。
  // お客様には書体名を出さず、ゴシック・イタリック・筆記体で見せる（2026-11-02 彩華さん。それまではフォントA・B・C）。注文の「書体」にもこの名前が残る。
  // scale は、同じ文字サイズで見た目の大きさをそろえるための倍率。sample は実際に刺繍した見本の画像（embroidery-font-◯◯-upper/lower.webp）
  var FONTS = [
    { name: 'ゴシック', sample: 'aqua', css: "'Aqua Grotesque', 'Didact Gothic', sans-serif", style: 'normal', weight: 400, scale: 0.9 },
    { name: 'イタリック', sample: 'calgary', css: "'Calgary', 'Cormorant Garamond', serif", style: 'italic', weight: 400, scale: 1.15 },
    { name: '筆記体', sample: 'script4', css: "'Script 4 Preview', 'Dancing Script', cursive", style: 'normal', weight: 600, scale: 1.3 }
  ];

  // 糸色を選ぶ前のお名前の色。どの本体色でも読みやすいレンガ（2026-10-29 彩華さん。以前のグレーは読みにくかった）
  var DEFAULT_NAME_COLOR = '#B54731';

  // 「刺繍まわり」は、モチーフの上端からお名前の下端までが枠の高さの ZOOM_FILL になるまで拡大する（2026-10-30 彩華さん。
  // 以前は 2.3 倍固定で、刺繍の小さい商品では周りが見えすぎていた。同日、お名前が小さいので半分→6割に）。倍率は ZOOM_MIN〜ZOOM_MAX の間に収める
  var ZOOM_FILL = 60;
  var ZOOM_MIN = 2.3;
  var ZOOM_MAX = 6;
  // お名前が長いときは、横幅が枠の ZOOM_NAME_WIDTH に収まるところまで拡大を抑える（2026-10-31 彩華さん。10文字で左右が切れた）
  var ZOOM_NAME_WIDTH = 0.88;
  // 柄の画像は上下に余白があるので、絵の高さは画像の大きさの6割と見る。お名前は一番大きく出る書体の倍率で見る
  var MOTIF_INK = 0.6;
  var NAME_SCALE_MAX = 1.3;
  // 刺繍の中心を置く位置（枠に対する%）。切り替えボタンは右下の隅なので、中心は枠の真ん中（2026-11-04。それまではボタンが下の真ん中にあり45）
  var ZOOM_TARGET_X = 50;
  var ZOOM_TARGET_Y = 50;

  var ORDER = ['motif', 'name', 'agree'];
  var LABEL = { motif: 'モチーフ', name: 'お名前', agree: '内容確認' };

  var CAPTION_PHOTO = '写真に重ねた刺繍はイメージです。実際の仕上がりとは、大きさ・色・書体の見え方が異なる場合があります。';
  var CAPTION_PLAIN = '表示している刺繍はイメージです。実際の仕上がりとは、大きさ・色・書体の見え方が異なる場合があります。';

  function characters(text) {
    return Array.from(text || '');
  }

  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return '&#' + c.charCodeAt(0) + ';';
    });
  }

  function emptyState() {
    return { motif: null, name: '', font: null, thread: null, skipName: false };
  }

  /**
   * モチーフ画像は全柄が同じ縮尺の正方形（柄の周りは透明）。
   * 一覧では柄の外枠に合わせて拡大して見せたいので、透明でない範囲を測って倍率とずらし量を出す。
   */
  var fitCache = {};
  function measureMotif(src) {
    if (fitCache[src]) return fitCache[src];

    fitCache[src] = new Promise(function (resolve) {
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = function () {
        try {
          var size = 120;
          var canvas = document.createElement('canvas');
          canvas.width = size;
          canvas.height = size;
          var context = canvas.getContext('2d');
          context.drawImage(image, 0, 0, size, size);
          var data = context.getImageData(0, 0, size, size).data;
          var x0 = size, y0 = size, x1 = -1, y1 = -1;

          for (var y = 0; y < size; y++) {
            for (var x = 0; x < size; x++) {
              if (data[(y * size + x) * 4 + 3] > 10) {
                if (x < x0) x0 = x;
                if (x > x1) x1 = x;
                if (y < y0) y0 = y;
                if (y > y1) y1 = y;
              }
            }
          }

          if (x1 < 0) return resolve(null);

          var centerX = (x0 + x1 + 1) / 2;
          var centerY = (y0 + y1 + 1) / 2;
          var extent = Math.max(x1 - x0 + 1, y1 - y0 + 1);
          var scale = Math.min((0.8 * size) / extent, 3.2);

          resolve({
            scale: scale,
            dx: ((size / 2 - centerX) / size) * 100 * scale,
            dy: ((size / 2 - centerY) / size) * 100 * scale
          });
        } catch (error) {
          resolve(null);
        }
      };
      image.onerror = function () {
        resolve(null);
      };
      image.src = src;
    });

    return fitCache[src];
  }

  function fitMotifImage(img) {
    measureMotif(img.getAttribute('data-src')).then(function (fit) {
      if (!fit) return;
      img.style.transform =
        'translate(-50%, -50%) translate(' + fit.dx + '%, ' + fit.dy + '%) scale(' + fit.scale + ')';
    });
  }

  /** 円だけを前提にしている（小数のない金額）。書式はストアの設定（例 ¥{{amount_no_decimals}}） */
  function formatMoney(cents) {
    var format = (window.themeVariables && window.themeVariables.settings.moneyFormat) || '¥{{amount_no_decimals}}';
    return format.replace(/\{\{\s*\w+\s*\}\}/, Math.round(cents / 100).toLocaleString('ja-JP'));
  }

  var EmbroideryOptions = class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      var dataElement = this.querySelector('[data-embroidery-data]');
      this.data = dataElement ? JSON.parse(dataElement.textContent) : { groups: [], threads: [], photos: [] };
      this.maxLength = parseInt(this.dataset.maxLength, 10) || 10;
      this.form = document.getElementById(this.dataset.formId);
      this.variantTitle = this.data.variant || '';

      this.dialog = this.querySelector('.emb-modal');
      this.openButton = this.querySelector('[data-embroidery-open]');
      this.nameInput = this.querySelector('[data-emb-name]');
      this.doneButton = this.querySelector('[data-emb-done]');
      this.agree = this.querySelector('[data-emb-agree]');
      this.agreeInput = this.querySelector('[data-emb-agree-input]');
      this.agreedFor = null;
      this.preview = this.querySelector('[data-emb-preview]');

      this.steps = {};
      Array.from(this.querySelectorAll('.emb-step')).forEach(function (step) {
        this.steps[step.dataset.step] = step;
      }, this);

      this.state = emptyState();
      this.draft = emptyState();
      this.filter = 'all';
      this.openKey = null;

      this.setUpZoom();
      this.setUpSticky();
      this.bindEvents();
      this.syncOpenButton();
    }

    /* ---------- 商品ページ側 ---------- */

    /** 売り切れ・取り扱いのない組み合わせのときは「刺繍を選ぶ」も押せないようにして、カートボタンと同じ文言にする */
    syncOpenButton(variant) {
      var unavailable = variant === null || (variant ? !variant.available : this.dataset.available !== 'true');
      var label = variant === null ? this.dataset.unavailableLabel : this.dataset.soldOutLabel;

      this.openButton.disabled = unavailable;
      this.openButton.textContent = unavailable ? label : '刺繍を選ぶ';
      this.openButton.classList.toggle('button--outline', unavailable);

      if (this.stickyButton) {
        this.stickyButton.disabled = unavailable;
        this.stickyButton.textContent = this.openButton.textContent;
        this.stickyButton.classList.toggle('button--outline', unavailable);
      }
    }

    /** スマホで、上の「刺繍を選ぶ」が画面に無いあいだ、画面の下に同じボタンを出す（PC は CSS で出さない） */
    setUpSticky() {
      this.sticky = this.querySelector('[data-emb-sticky]');
      if (!this.sticky) return;

      // 祖先に transform などがあると position: fixed が画面に固定されないので、body の直下へ移す。
      // 商品欄が描き直されたときに前のバーが残らないよう、先に消しておく
      Array.from(document.querySelectorAll('body > .emb-sticky')).forEach(function (old) {
        old.remove();
      });
      document.body.appendChild(this.sticky);
      this.stickyButton = this.sticky.querySelector('[data-emb-sticky-open]');

      var self = this;
      this.stickyButton.addEventListener('click', function () {
        self.open();
      });

      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        // ボタンを過ぎてから出す。ボタンにたどり着く前（ボタンが画面より下）は出さない（2026-11-03 彩華さん）
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        self.sticky.classList.toggle('is-visible', show);
        self.sticky.inert = !show;
        document.documentElement.style.setProperty('--emb-sticky-height', self.sticky.offsetHeight + 'px');
        document.documentElement.classList.toggle('emb-has-sticky', show);
      }).observe(this.openButton);
      this.sticky.inert = true;
    }

    renderSticky(variant) {
      if (!this.sticky || !variant) return;
      this.sticky.querySelector('[data-emb-sticky-variant]').textContent = variant.title.split(' / ').join('・');
      this.sticky.querySelector('[data-emb-sticky-price]').textContent = formatMoney(variant.price);
    }

    bindEvents() {
      var self = this;

      this.openButton.addEventListener('click', function () {
        self.open();
      });

      // 色・サイズを切り替えたら、在庫の状態と、モーダルの見出しに出す色・サイズを合わせる
      document.addEventListener('variant:change', function (event) {
        // detail.formId は form.id（name="id" の入力欄）を指してしまうので、送り元のフォームで見分ける
        if (!event.detail || event.target !== document.getElementById(self.dataset.formId)) return;
        var variant = event.detail.variant || null;
        if (variant) self.variantTitle = variant.title;
        self.syncOpenButton(variant);
        self.renderSticky(variant);
      });

      if (this.form) {
        // モーダルを通らない送信（数量欄で Enter など）は止めて、モーダルを開く
        this.form.addEventListener(
          'submit',
          function (event) {
            if (self.submitting) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            self.open();
          },
          true
        );

        this.form.addEventListener('variant:add', function () {
          self.afterAdded();
        });

        this.form.addEventListener('cart:error', function (event) {
          self.submitting = false;
          self.doneButton.removeAttribute('aria-busy');
          self.update();
          self.setFoot('<b>カートに入れられませんでした</b>' + escapeHtml((event.detail && event.detail.error) || ''));
        });
      }

      // モーダルの中
      this.dialog.addEventListener('click', function (event) {
        // 枠の外（背景）を押したら閉じる
        if (event.target === self.dialog) self.close();
      });
      this.querySelector('[data-emb-close]').addEventListener('click', function () {
        self.close();
      });
      this.dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('emb-is-locked');
      });

      this.querySelector('[data-emb-filters]').addEventListener('click', function (event) {
        var button = event.target.closest('button');
        if (!button) return;
        self.filter = button.dataset.filter;
        Array.from(this.querySelectorAll('button')).forEach(function (x) {
          x.setAttribute('aria-pressed', String(x === button));
        });
        self.renderMotifs();
      });

      this.querySelector('[data-emb-motifs]').addEventListener('click', function (event) {
        var button = event.target.closest('.emb-motif');
        if (!button) return;
        self.draft.motif = button.dataset.motif;
        Array.from(this.querySelectorAll('.emb-motif')).forEach(function (x) {
          x.setAttribute('aria-checked', String(x === button));
        });
        self.update();
      });

      this.nameInput.addEventListener('input', function () {
        self.sanitize();
        self.draft.name = self.nameInput.value.trim();
        self.draft.skipName = false;
        self.renderFonts();
        self.update();
      });

      // フォームの中にあるので、Enter で商品フォームが送信されないようにする
      this.nameInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') event.preventDefault();
      });

      this.querySelector('[data-emb-fonts]').addEventListener('click', function (event) {
        var button = event.target.closest('.emb-font');
        if (!button) return;
        self.draft.font = Number(button.dataset.font);
        Array.from(this.querySelectorAll('.emb-font')).forEach(function (x) {
          x.setAttribute('aria-checked', String(x === button));
        });
        self.renderFontSample();
        self.update();
      });

      this.querySelector('[data-emb-threads]').addEventListener('click', function (event) {
        var button = event.target.closest('.emb-thread');
        if (!button) return;
        self.draft.thread = Number(button.dataset.thread);
        Array.from(this.querySelectorAll('.emb-thread')).forEach(function (x) {
          x.setAttribute('aria-checked', String(x === button));
        });
        self.renderFonts();
        self.update();
      });

      Array.from(this.querySelectorAll('.emb-step__head')).forEach(function (head) {
        head.addEventListener('click', function () {
          var step = head.parentElement;
          self.openStep(step.classList.contains('is-open') ? null : step.dataset.step);
        });
      });

      this.agreeInput.addEventListener('change', function () {
        self.agreedFor = self.agreeInput.checked ? self.selection() : null;
        self.update();
      });

      this.doneButton.addEventListener('click', function () {
        var mode = self.doneButton.dataset.mode;
        if (mode === 'next') return self.openStep(self.doneButton.dataset.target);
        if (mode === 'skip') return self.skipName();
        self.addToCart();
      });
    }

    /* ---------- 開く・閉じる ---------- */

    open() {
      if (this.openButton.disabled) return;

      this.draft = JSON.parse(JSON.stringify(this.state));
      this.resetAgree();
      this.querySelector('[data-emb-sub]').textContent =
        this.data.product + (this.variantTitle ? '・' + this.variantTitle : '');
      this.nameInput.value = this.draft.name;
      this.querySelector('[data-emb-name-error]').hidden = true;
      this.filter = 'all';

      this.setUpPhoto();
      this.renderFilters();
      this.renderMotifs();
      this.renderFonts();
      this.renderThreads();

      document.documentElement.classList.add('emb-is-locked');
      this.dialog.showModal();
      this.openStep(this.firstIncomplete());
      this.querySelector('[data-emb-body]').scrollTop = 0;
      this.querySelector('[data-emb-close]').focus();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
      document.documentElement.classList.remove('emb-is-locked');
    }

    /* ---------- 仕上がりのイメージ ---------- */

    /**
     * 重ねる写真。代替テキストに「刺繍プレビュー」が入った写真のうち、表示中の色のもの。
     * どれが表示中の色かは、商品ギャラリーで隠されていない目印の写真で判断する
     */
    previewPhoto() {
      var photos = this.data.photos || [];
      if (!photos.length) return null;

      var visible = document.querySelector('.product-gallery__media[data-embroidery-preview-target]:not([hidden])');
      if (visible) {
        var id = Number(visible.getAttribute('data-media-id'));
        var match = photos.filter(function (photo) {
          return photo.id === id;
        })[0];
        if (match) return match;
      }

      return photos[0];
    }

    setUpPhoto() {
      var photo = this.previewPhoto();
      var image = this.querySelector('[data-emb-photo]');

      if (photo) {
        image.src = photo.src;
        image.hidden = false;
      } else {
        image.removeAttribute('src');
        image.hidden = true;
      }

      // 写真が無いときは柄とお名前だけを大きく見せる。位置は商品ごとの値を使わない
      this.preview.classList.toggle('is-plain', !photo);
      this.preview.classList.toggle('is-zoom', Boolean(photo) && this.zoomed !== false);
      this.querySelector('[data-emb-zoom]').hidden = !photo;
      this.querySelector('[data-emb-caption]').textContent = photo ? CAPTION_PHOTO : CAPTION_PLAIN;
    }

    /** 「刺繍まわり」と「全体」の切り替え。刺繍（モチーフの上端〜お名前の下端）の中心を枠の中央より少し上に置く */
    setUpZoom() {
      var self = this;
      var data = this.dialog.dataset;
      var motifX = parseFloat(data.motifX) || 50;
      var motifY = parseFloat(data.motifY) || 38;
      var motifSize = parseFloat(data.motifSize) || 18;
      var nameX = parseFloat(data.nameX) || 50;
      var nameY = parseFloat(data.nameY) || 52;
      var nameSize = parseFloat(data.nameSize) || 6;

      var top = motifY - (motifSize * MOTIF_INK) / 2;
      var bottom = nameY + (nameSize * NAME_SCALE_MAX) / 2;
      this.baseZoom = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, ZOOM_FILL / (bottom - top)));
      this.zoomCenterX = (motifX + nameX) / 2;
      this.zoomCenterY = (top + bottom) / 2;
      this.applyZoom();

      Array.from(this.querySelectorAll('[data-zoom]')).forEach(function (button) {
        button.addEventListener('click', function () {
          self.zoomed = button.dataset.zoom === '1';
          self.preview.classList.toggle('is-zoom', self.zoomed);
          Array.from(self.querySelectorAll('[data-zoom]')).forEach(function (x) {
            x.setAttribute('aria-pressed', String(x === button));
          });
        });
      });
    }

    /** 拡大率と位置を決める。お名前の幅は写真の幅に対する割合で見るので、今の拡大率に左右されない */
    applyZoom() {
      var zoom = this.baseZoom;
      var inner = this.preview.querySelector('.emb-preview__inner');
      var name = this.querySelector('[data-emb-pv-name]');
      var share = inner && name && inner.clientWidth ? name.offsetWidth / inner.clientWidth : 0;
      if (share > 0) zoom = Math.max(1, Math.min(zoom, ZOOM_NAME_WIDTH / share));

      var limit = -(zoom - 1) * 100;
      var translateX = Math.min(0, Math.max(limit, ZOOM_TARGET_X - this.zoomCenterX * zoom));
      var translateY = Math.min(0, Math.max(limit, ZOOM_TARGET_Y - this.zoomCenterY * zoom));

      this.preview.style.setProperty('--emb-zoom-left', translateX + '%');
      this.preview.style.setProperty('--emb-zoom-top', translateY + '%');
      this.preview.style.setProperty('--emb-zoom-size', zoom * 100 + '%');
    }

    /* ---------- 一覧の描画 ---------- */

    allMotifs() {
      return this.data.groups.reduce(function (all, group) {
        return all.concat(group.items);
      }, []);
    }

    findMotif(id) {
      return (
        this.allMotifs().filter(function (motif) {
          return motif.id === id;
        })[0] || null
      );
    }

    renderFilters() {
      var container = this.querySelector('[data-emb-filters]');
      var named = this.data.groups.filter(function (group) {
        return group.name;
      });

      // グループが1つしかない（見出しなし）ときは絞り込みを出さない
      if (named.length < 2) {
        container.hidden = true;
        return;
      }

      var html = '<button type="button" data-filter="all" aria-pressed="true">すべて</button>';
      this.data.groups.forEach(function (group, index) {
        html += '<button type="button" data-filter="' + index + '" aria-pressed="false">' + escapeHtml(group.name) + '</button>';
      });
      container.innerHTML = html;
      container.hidden = false;
    }

    renderMotifs() {
      var self = this;
      var html = '';

      this.data.groups.forEach(function (group, index) {
        if (self.filter !== 'all' && String(index) !== self.filter) return;

        var label = group.name || 'モチーフ';
        html += '<div class="emb-motif-group">';
        if (group.name) html += '<p class="emb-motif-group__name">' + escapeHtml(group.name) + '</p>';
        html += '<div class="emb-motifs" role="radiogroup" aria-label="' + escapeHtml(label) + '">';

        if (index === 0 && self.filter === 'all') {
          html +=
            '<button type="button" class="emb-motif emb-motif--none" role="radio" data-motif="" aria-checked="' + (self.draft.motif === '') + '">' +
            '<span class="emb-motif__img"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M5.6 18.4 18.4 5.6"/></svg></span>' +
            '<span class="emb-motif__name">入れない</span></button>';
        }

        group.items.forEach(function (motif) {
          html +=
            '<button type="button" class="emb-motif" role="radio" data-motif="' + escapeHtml(motif.id) + '" aria-checked="' + (self.draft.motif === motif.id) + '">' +
            '<span class="emb-motif__img">' +
            (motif.src ? '<img src="' + escapeHtml(motif.src) + '" data-src="' + escapeHtml(motif.src) + '" alt="" loading="lazy">' : '') +
            '</span><span class="emb-motif__name">' + escapeHtml(motif.name) + '</span></button>';
        });

        html += '</div></div>';
      });

      var container = this.querySelector('[data-emb-motifs]');
      container.innerHTML = html;
      Array.from(container.querySelectorAll('img[data-src]')).forEach(fitMotifImage);
    }

    renderFonts() {
      var sample = this.draft.name || 'Name';
      var thread = this.draft.name && this.draft.thread !== null ? this.data.threads[this.draft.thread] : null;
      var draft = this.draft;

      this.querySelector('[data-emb-fonts]').innerHTML = FONTS.map(function (font, index) {
        return (
          '<button type="button" class="emb-font" role="radio" data-font="' + index + '" aria-checked="' + (draft.font === index) + '">' +
          '<span class="emb-font__sample' + (draft.name ? '' : ' is-placeholder') + '" style="font-family:' + escapeHtml(font.css) +
          ';font-style:' + font.style + ';font-weight:' + font.weight + ';font-size:' + Math.round(17 * font.scale) + 'px' + (thread ? ';color:' + thread.hex : '') + '">' +
          escapeHtml(sample) + '</span>' +
          '<span class="emb-font__name">' + escapeHtml(font.name) + '</span></button>'
        );
      }).join('');

      this.renderFontSample();
    }

    /** 選んでいる書体を実際に刺繍した見本（大文字・小文字）を、書体のボタンの下に出す */
    renderFontSample() {
      var box = this.querySelector('[data-emb-font-sample]');
      var font = this.draft.font !== null ? FONTS[this.draft.font] : null;
      var urls = font && this.data.fontSamples ? this.data.fontSamples[font.sample] : null;

      box.hidden = !urls;
      if (!urls || box.dataset.sample === font.sample) return;
      box.dataset.sample = font.sample;
      box.innerHTML =
        '<div class="emb-font-sample__images">' +
        '<img src="' + escapeHtml(urls.upper) + '" width="1000" height="750" alt="' + escapeHtml(font.name) + ' の大文字を刺繍した見本">' +
        '<img src="' + escapeHtml(urls.lower) + '" width="1000" height="750" alt="' + escapeHtml(font.name) + ' の小文字を刺繍した見本">' +
        '</div>' +
        '<p class="emb-font-sample__note">書体の刺繍見本です。糸の色は、お選びの糸色で刺繍します。</p>';
    }

    renderThreads() {
      var draft = this.draft;

      this.querySelector('[data-emb-threads]').innerHTML = this.data.threads.map(function (thread, index) {
        return (
          '<button type="button" class="emb-thread" role="radio" data-thread="' + index + '" aria-checked="' + (draft.thread === index) + '">' +
          '<span class="emb-thread__dot" style="background:' + escapeHtml(thread.hex) + '"></span>' + escapeHtml(thread.name) + '</button>'
        );
      }).join('');
    }

    /* ---------- 手順 ---------- */

    complete(key) {
      if (key === 'motif') return this.draft.motif !== null;
      if (key === 'agree') return this.agreeInput.checked;
      return this.draft.skipName || (Boolean(this.draft.name) && this.draft.font !== null && this.draft.thread !== null);
    }

    /** 刺繍が1つでも選ばれているか。モチーフもお名前も「入れない」なら、内容確認には進まない */
    hasEmbroidery() {
      return Boolean(this.draft.motif) || Boolean(this.draft.name);
    }

    firstIncomplete() {
      for (var i = 0; i < ORDER.length; i++) {
        if (ORDER[i] === 'agree' && !this.hasEmbroidery()) return null;
        if (!this.complete(ORDER[i])) return ORDER[i];
      }
      return null;
    }

    /** 開くのは常に1つ */
    openStep(key) {
      var self = this;

      Object.keys(this.steps).forEach(function (k) {
        var open = k === key;
        self.steps[k].classList.toggle('is-open', open);
        self.steps[k].querySelector('.emb-step__head').setAttribute('aria-expanded', String(open));
      });

      this.openKey = key;
      this.update();

      if (key === 'name' && !this.draft.name) {
        setTimeout(function () {
          self.nameInput.focus({ preventScroll: true });
        }, 50);
      }

      if (key && window.matchMedia('(max-width: 760px)').matches) {
        this.steps[key].scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }

    /** お名前を入れない。書体と糸色はお名前にだけ付くので、一緒に飛ばす */
    skipName() {
      this.draft.name = '';
      this.draft.font = null;
      this.draft.thread = null;
      this.draft.skipName = true;
      this.nameInput.value = '';
      this.querySelector('[data-emb-name-error]').hidden = true;
      this.renderFonts();
      this.openStep(this.firstIncomplete());
    }

    /** 刺繍できない文字を取り除く。入力された大文字・小文字はそのまま保持する */
    sanitize() {
      var kept = [];
      var dropped = false;

      characters(this.nameInput.value).forEach(function (character) {
        if (ALLOWED.test(character)) {
          kept.push(character);
        } else {
          dropped = true;
        }
      });

      var value = kept.slice(0, this.maxLength).join('');
      if (this.nameInput.value !== value) this.nameInput.value = value;

      this.querySelector('[data-emb-name-error]').hidden = !dropped;
      this.nameInput.setAttribute('aria-invalid', String(dropped));
    }

    /* ---------- 表示の更新 ---------- */

    setValue(key, html) {
      this.steps[key].querySelector('[data-value]').innerHTML = html ? html + ' <span class="emb-step__edit">変更</span>' : '';
    }

    setFoot(html) {
      this.querySelector('[data-emb-foot]').innerHTML = html;
    }

    /** 同意の対象になる今の選択内容 */
    selection() {
      var draft = this.draft;
      return JSON.stringify([draft.motif, draft.name, draft.font, draft.thread]);
    }

    resetAgree() {
      this.agreeInput.checked = false;
      this.agreedFor = null;
    }

    /** 内容確認の手順に出す、選んだ内容の一覧 */
    renderReview(motif, thread) {
      var draft = this.draft;
      var rows = [['サイズ・本体カラー', this.variantTitle], ['モチーフ', motif ? motif.name : '入れない'], ['お名前', draft.name || '入れない']];

      if (draft.name) {
        rows.push(['書体', draft.font !== null ? FONTS[draft.font].name : '']);
        rows.push(['糸色', thread ? thread.name : '']);
      }

      this.querySelector('[data-emb-review]').innerHTML = rows
        .filter(function (row) {
          return row[1];
        })
        .map(function (row) {
          return '<dt>' + escapeHtml(row[0]) + '</dt><dd>' + escapeHtml(row[1]) + '</dd>';
        })
        .join('');
    }

    update() {
      var draft = this.draft;
      var motif = draft.motif ? this.findMotif(draft.motif) : null;
      var thread = draft.thread !== null ? this.data.threads[draft.thread] : null;
      var font = FONTS[draft.font !== null ? draft.font : 0];

      // プレビュー
      var previewMotif = this.querySelector('[data-emb-pv-motif]');
      if (motif && motif.src) {
        previewMotif.src = motif.full || motif.src;
        previewMotif.hidden = false;
      } else {
        previewMotif.hidden = true;
      }

      var previewName = this.querySelector('[data-emb-pv-name]');
      previewName.textContent = draft.name;
      previewName.style.fontFamily = font.css;
      previewName.style.fontStyle = font.style;
      previewName.style.fontWeight = font.weight;
      previewName.style.setProperty('--emb-font-scale', font.scale);
      previewName.style.color = thread ? thread.hex : DEFAULT_NAME_COLOR;
      this.applyZoom();
      // 書体の読み込みが終わると文字の幅が変わるので、もう一度合わせる
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.applyZoom.bind(this));

      // 見出しの右に選んだ内容
      this.setValue('motif', draft.motif === null ? '' : escapeHtml(motif ? motif.name : '入れない'));
      this.setValue(
        'name',
        draft.name
          ? (thread ? '<span class="emb-dot" style="background:' + escapeHtml(thread.hex) + '"></span>' : '') +
              escapeHtml(draft.name) +
              (draft.font !== null ? '・' + escapeHtml(FONTS[draft.font].name) : '')
          : draft.skipName
            ? '入れない'
            : ''
      );

      this.steps.motif.classList.toggle('is-done', draft.motif !== null);
      this.steps.name.classList.toggle('is-done', this.complete('name'));

      // チェックのあとに内容を変えたら、同意をやり直してもらう
      if (this.agreedFor !== this.selection()) this.resetAgree();

      this.steps.agree.classList.toggle('is-done', this.complete('agree'));
      this.steps.agree.querySelector('.emb-step__head').disabled =
        !this.hasEmbroidery() || !this.complete('motif') || !this.complete('name');
      this.renderReview(motif, thread);

      // 下のボタン。次にやることが残っていれば「次へ」、全部そろえば「カートに追加」
      var hasAny = Boolean(motif) || Boolean(draft.name);
      var target = this.firstIncomplete();
      var button = this.doneButton;
      var summary = [motif ? motif.name : null, draft.name || null].filter(Boolean).join(' ＋ ');
      var foot;

      if (!target) {
        button.dataset.mode = 'cart';
        button.textContent = 'カートに追加';
        button.disabled = !hasAny;
        foot = hasAny
          ? '<b>' + escapeHtml(summary) + '</b>'
          : '<b>モチーフかお名前を選んでください</b>どちらか一方でもご注文いただけます';
      } else if (target !== this.openKey) {
        button.dataset.mode = 'next';
        button.dataset.target = target;
        button.textContent = '次へ：' + LABEL[target];
        button.disabled = false;
        foot = summary ? '<b>' + escapeHtml(summary) + '</b>' : '<b>刺繍を選んでください</b>';
      } else {
        // 開いている手順がまだ終わっていない。終わるまで押せない
        var after = ORDER[ORDER.indexOf(target) + 1];
        button.dataset.mode = after ? 'next' : 'cart';
        button.textContent = after ? '次へ：' + LABEL[after] : 'カートに追加';
        button.disabled = true;

        if (target === 'motif') {
          foot = '<b>モチーフを選んでください</b>入れない場合は「入れない」を選びます';
        } else if (target === 'agree') {
          foot = '<b>' + escapeHtml(summary) + '</b>内容をご確認のうえ、チェックを入れてください';
        } else if (!draft.name) {
          if (motif) {
            // モチーフが入っていれば、お名前なしでも注文できる
            button.dataset.mode = 'skip';
            button.textContent = 'お名前は入れずに次へ';
            button.disabled = false;
            foot = '<b>お名前を入れてください</b>入れない場合は、このまま次へ進めます';
          } else {
            foot = '<b>お名前を入れてください</b>モチーフを入れない場合は、お名前が必要です';
          }
        } else if (draft.font === null && draft.thread === null) {
          foot = '<b>書体と糸色を選んでください</b>お名前の書体と色です';
        } else if (draft.font === null) {
          foot = '<b>書体を選んでください</b>お名前の書体です';
        } else {
          foot = '<b>糸色を選んでください</b>お名前の色です';
        }
      }

      if (this.submitting) button.disabled = true;
      this.setFoot(foot);
    }

    /* ---------- カートに入れる ---------- */

    setField(key, value) {
      var input = this.querySelector('[data-embroidery-field="' + key + '"]');
      if (input) input.value = value || '';
    }

    addToCart() {
      if (!this.form || this.submitting) return;

      var draft = this.draft;
      var motif = draft.motif ? this.findMotif(draft.motif) : null;
      var thread = draft.name && draft.thread !== null ? this.data.threads[draft.thread] : null;
      var font = draft.name && draft.font !== null ? FONTS[draft.font] : null;

      // 「入れない」は空にする（カートの明細では空の項目は表示されない）
      this.setField('motif', motif ? motif.name : '');
      this.setField('name', draft.name);
      this.setField('font', font ? font.name : '');
      this.setField('thread', thread ? thread.name : '');
      this.setField('agree', this.agree.dataset.text);

      this.submitting = true;
      this.doneButton.disabled = true;
      this.doneButton.setAttribute('aria-busy', 'true');
      this.form.requestSubmit();
    }

    /** カートに入った。モーダルを閉じて、次の1着は最初から選ぶ（カートドロワーはテーマが開く） */
    afterAdded() {
      if (!this.submitting) return;

      this.submitting = false;
      this.doneButton.removeAttribute('aria-busy');
      this.state = emptyState();
      ['motif', 'name', 'font', 'thread', 'agree'].forEach(function (key) {
        this.setField(key, '');
      }, this);
      this.resetAgree();
      this.close();
    }
  };

  customElements.define('embroidery-options', EmbroideryOptions);
})();
